var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwIconsArtboard33(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 99.18 71.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: url(#New_Gradient_Swatch_4);\n        stroke-miterlimit: 10;\n        stroke-width: 1.35px;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4",
    "data-name": "New Gradient Swatch 4",
    x1: 0,
    y1: 35.74,
    x2: 99.18,
    y2: 35.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0079ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ae2f8"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.05,60.14v10.43M57.13,60.14v10.43M27.68,70.8h43.82M98.5,55.55V5.26c0-2.53-2.06-4.58-4.58-4.58H5.26C2.73.67.67,2.73.67,5.26v50.29c0,2.53,2.06,4.58,4.58,4.58h88.66c2.53,0,4.58-2.06,4.58-4.58Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwIconsArtboard33);
export default __webpack_public_path__ + "static/media/tw-icons-artboard-33.2d7b820bb0e9c9ae69e8c2c9ef5d71de.svg";
export { ForwardRef as ReactComponent };